import classnames from 'classnames';
import * as React from 'react';

interface OverlayProps extends React.HTMLProps<HTMLDivElement> {
	bgColor?: string;
	opacity: number;
}

export const Overlay: React.FC<OverlayProps> = ({
	bgColor = '#ffffff',
	opacity = 100,
	className,
	...props
}) => {
	return (
		<div
			className={classnames('absolute inset-0', className)}
			style={{
				backgroundColor: bgColor,
				opacity: (1 / (100 / opacity)).toString(),
			}}
			{...props}
		></div>
	);
};

export default Overlay;
